import { render, staticRenderFns } from "./PersonalSpace-activities.vue?vue&type=template&id=0035c916&"
import script from "./PersonalSpace-activities.vue?vue&type=script&lang=js&"
export * from "./PersonalSpace-activities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports